import React,{useState, useCallback, useEffect} from 'react'
import {Link} from 'react-router-dom'
import { Card,Button, Row, Col, Container } from 'react-bootstrap';
const Question = ({location}) =>{
    const [contestId, setContestId] = useState()
    const [questionsData, setQuestionsData] = useState({})
    const [loader, setLoader] = useState(true)
    
      
    
    const loadData = useCallback(async () =>{
        setLoader(true)
        const params = new URLSearchParams(location.search)
        const temp2 = params.get("UCI")
        setContestId(temp2)
        const response = await fetch(`https://codezap-e156b.firebaseio.com/contests/${temp2}.json`)
        const resData = await response.json()
        
        if(resData){
        if(resData["questions"]){
            
            
            setQuestionsData(resData["questions"])
        }}
        
            
        setLoader(false)
        
        
        
    },[location.search])

    
      useEffect(() =>{
        
        loadData()
        
    },[loadData])
    return(
        <section className = "hero">
            <header className="mb-4 shadow">
                <nav className="navbar navbar-dark bg-dark primary-styled-border">
                    <div className="container">
                        <Link to = "/compete" style = {{color:"white"}}>
                            <i className="fa fa-arrow-left" aria-hidden="true" style = {{fontSize:"40px"}}></i>
                        </Link>
                        
                        <div>
                        
                        
                        {loader ? <p></p>:<h1 style = {{color:"white"}}> {contestId.split("_").join(" ").substring(0, contestId.split("_").join(" ").length - 4)}</h1>}
                        </div>
                    </div>
                </nav>
        </header> 
            
            <Container style = {{marginTop:"3%"}}>
            <h1>Questions</h1>
            <Row>
                
                    {
                        Object.keys(questionsData).map((item,i) => 
                            <Col sm = {4} key = {item} style = {{marginBottom:"1%",marginTop:"1%"}}>
                                <Card style={{ width: '100%' }}>
                                    
                                    <Card.Body>
                                        <Card.Title>{item.split("_").join(" ").substring(0, item.split("_").join(" ").length - 4)}</Card.Title>
                                        <Card.Text> 
                                            
                                            
                                        </Card.Text>
                                        <Link to = {'/solvequestion?UQI='+item+"@"+contestId}>
                                            <Button style = {{backgroundColor:"#FF405F", color:"white", borderColor:"#FF405F"}}>Solve Question</Button>
                                        </Link>
                                    </Card.Body>
                                </Card>
                            </Col>
                            )
                    }
                    
                    
            </Row>
            <Link to = {"/leaderboard?UCI="+contestId} >
            <button className = "btn btn-info" id="leaderboard"  style = {{width:"20%",margin:"0.5% 2%",marginLeft:"71%"}}>Leaderboard</button>  
            </Link>
            </Container>
            
            
        </section>
    )
}

export default Question